export class Page<T> {

  public size: number;

  constructor(
    public content: T[],
    public totalElements: number, // all elements in DB
    public totalPages: number, // all existing pages
    public numberOfElements: number, // elements/page
    public number: number, // page number
    public last: boolean,
    public first: boolean,
    public pageable?: {
      "pageNumber": number,
      "pageSize": number,
      "sort": {
        "active": string,
        "direction": string
      }
    },
  ) {

  }
}
